module.exports = {"621122100":"巩昌镇","621122101":"文峰镇","621122102":"首阳镇","621122103":"菜子镇","621122104":"福星镇","621122105":"通安驿镇","621122106":"云田镇","621122107":"碧岩镇","621122108":"马河镇","621122109":"柯寨镇","621122110":"双泉镇","621122111":"权家湾镇","621122200":"渭阳乡","621122201":"宏伟乡","621122202":"和平乡","621122205":"德兴乡","621122206":"永吉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621122.json
// module id = 3088
// module chunks = 0